export default {
  getAccessToken: state => state.accessToken,
  getRefreshToken: state => state.refreshToken,
  getUserData: state => state.userData,
  getDeviceInfo: state => state.deviceInfo,
  getRole: state => state.role,
  getSignUp: state => state.signUp,
  getFamilyList: state => state.familyList,
  getTTL: state => state.ttl,
  getPurchaseCallBack: state => state.purchaseCallBack,
  getDuplicated: state => state.signUp.duplicated,
  getTerms: state => state.terms,
  getChurchNo: state => state.userData.churchNo,
  getAuthCode: state => state.authCode,
  getFirstLogin: state => state.firstLoginChk,
  getFindData: state => state.find.form,
  getPurchase: state => state.purchase,
  getFamilyCode: state => state.userData?.familyCode,
  getFamilyName: state => state.userData?.familyName,
  getIsNotFamily: state => state.userData?.isNotFamily,
  getIsRepresent: state => state.userData?.isRepresent,
  getRepresentFamilyCode: state => state.userData?.representFamilyCode,
  getPassExpireDate: state => state.userData?.passExpireDate,
  getRepresentFamilyName: state => state.userData?.representFamilyName,
  getCurrentPresent: state => state.userData?.currentRepresent,
  getAgreeMarketing: state => state.userData?.isAgreeMarketing,
  getAgreeBusinessMarketingPush: state => state.userData?.isAgreeBusinessMarketingPush,
  getPhone: state => state.phone,
  getPhoneInfo: state => {
    return { phone: state.phone, code: state.code };
  },
  getIsSns: state => state.signUp.isSns,
  getIsPremium: state => state.signUp.isPremium,
  getCouponNumber: state => state.signUp.couponNumber,
  getJoinType: state => state.signUp.form.joinType,
  getFindAccounts: state => state.findAccounts
};
